import React from 'react';
import { Box, LoadingOverlay } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { useBetterAuthUserStore } from 'store/betterAuthUserStore';
import { useBetterAuth } from 'context/BetterAuthProvider';

const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('core');
  const { userData, fetchError } = useBetterAuthUserStore();
  const { logout } = useBetterAuth();

  React.useEffect(() => {
    if (fetchError) {
      showNotification({
        title: t('core:error'),
        message: fetchError,
        color: 'red',
      });
      logout();
    }
  }, [fetchError, t, logout]);

  if (userData?.me?.userId) {
    return (
      <React.Suspense fallback={<LoadingOverlay visible />}>
        <Box>{children}</Box>
      </React.Suspense>
    );
  } else {
    return (
      <React.Suspense fallback={<LoadingOverlay visible />}>
        <Box>
          <LoadingOverlay visible={true} />
        </Box>
      </React.Suspense>
    );
  }
};

export default UserProvider;
